import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './OurServices.css';

const services = [
  {
    id: 1,
    slug: 'buy-sell-property',
    title: 'Buy Or Sell Property',
    desc: 'Find your perfect home or get the best price for your property with our expert guidance and market insights.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80',
    icon: 'fa-house',
  },
  {
    id: 2,
    slug: 'rent-lease-property',
    title: 'Rent Or Lease Property',
    desc: 'Premium rental listings with verified owners and assured returns. Hassle-free leasing process from Day 1.',
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80',
    icon: 'fa-key',
  },
  {
    id: 3,
    slug: 'commercial-properties',
    title: 'Commercial Properties',
    desc: 'Retail shops, office spaces and commercial plots in high-footfall zones for maximum business growth.',
    image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&q=80',
    icon: 'fa-building',
  },
  {
    id: 4,
    slug: 'investment-advisory',
    title: 'Investment Advisory',
    desc: 'Expert advice on high-ROI real estate investments. We identify the best opportunities before the market does.',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&q=80',
    icon: 'fa-chart-line',
  },
  {
    id: 5,
    slug: 'home-loan-assistance',
    title: 'Home Loan Assistance',
    desc: 'Get the best home loan deals with our bank tie-ups. Quick approvals, low interest, minimal documentation.',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&q=80',
    icon: 'fa-hand-holding-dollar',
  },
  {
    id: 6,
    slug: 'legal-registration',
    title: 'Legal & Registration',
    desc: 'End-to-end legal support — from title verification to registration. Your property is safe with us.',
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80',
    icon: 'fa-file-contract',
  },
];

const stats = [
  { num: '378+',   label: 'Properties Sold' },
  { num: '1,075+', label: 'Properties Leased' },
  { num: '7+',     label: 'Real Estate Awards' },
  { num: '34+',    label: 'Collaborations' },
];

export default function OurServices() {
  const [hovered, setHovered] = useState(null);

  return (
    <section className="services-section">
      <div className="services-inner">

        {/* ── HEADER ── */}
        <div className="services-header">
          <div className="services-label">
            <span className="services-label-box" />
            <span className="services-label-box offset" />
            Our Services
          </div>
          <p className="services-sub">Tailored Solutions by Expert Real Estate Agents</p>
          <div className="services-underline" />
        </div>

        {/* ── SERVICE CARDS ── */}
        <div className="services-grid">
          {services.map((s) => (
            <div
              key={s.id}
              className={`service-card ${hovered === s.id ? 'hovered' : ''}`}
              onMouseEnter={() => setHovered(s.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <div className="service-img-wrap">
                <img src={s.image} alt={s.title} />
                <div className="service-img-overlay" />
                <div className="service-icon-badge">
                  <i className={`fa ${s.icon}`} />
                </div>
              </div>
              <div className="service-body">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <Link to={`/services/${s.slug}`} className="service-btn">
                  Learn more <i className="fa fa-arrow-right" />
                </Link>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* ── STATS STRIP ── */}
      <div className="services-stats-strip">
        <div className="stats-strip-bg">
          <img
            src="https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1400&q=60"
            alt="City"
            className="stats-bg-img"
          />
          <div className="stats-bg-overlay" />
        </div>
        <div className="stats-strip-content">
          <div className="stats-strip-left">
            <h3>Delivering Results For<br />Over 30 Years</h3>
            <p>Trusted Real Estate Agents at<br />Your Service!</p>
          </div>
          <div className="stats-strip-numbers">
            {stats.map((s, i) => (
              <div key={i} className="strip-stat">
                <strong>{s.num}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
}
